interface SchemaTabProps {
  formValues: Record<string, unknown>;
}

export function SchemaTab({ formValues }: SchemaTabProps) {
  return (
    <div className="flex-1 bg-slate-950 p-6 font-mono text-[11px] overflow-auto h-full">
      <div className="text-slate-500 mb-4 pb-2 border-b border-slate-800 flex justify-between items-center">
        <span className="uppercase tracking-widest font-bold">Payload Data</span>
        <span className="text-green-500/70">application/json</span>
      </div>
      <pre className="text-green-400/90 leading-relaxed">{JSON.stringify(formValues, null, 2)}</pre>
    </div>
  );
}
